import { render, staticRenderFns } from "./ProfileCompletionReminder.vue?vue&type=template&id=1d61c967&scoped=true"
import script from "./ProfileCompletionReminder.vue?vue&type=script&lang=js"
export * from "./ProfileCompletionReminder.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompletionReminder.vue?vue&type=style&index=0&id=1d61c967&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61c967",
  null
  
)

export default component.exports